import React, { useState } from "react";
import { Row, Col } from "antd";
import CodeInput from "component/component/code_input";
import { useSignUp } from "hook/useAuth";
import TriggerCountdown from "../trigger/trigger_countdown";
import VerifyCountdown from "./verify_countdown";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const RegisterVerify = () => {
  // -------------------------- VAR -----------------------------
  const { onChangeCode, checking } = useSignUp();
  // -------------------------- STATE ---------------------------
  const [countdown, setCountdown] = useState(null);
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Row justify={"center"}>
      <Col align="center" xl={24} lg={24} md={24} xs={24}>
        <CodeInput onChangeCode={onChangeCode} checking={checking} />
      </Col>
      <Col align="center" xl={24} lg={24} md={24} xs={24}>
        <VerifyCountdown
          setCountdown={setCountdown}
          countdown={countdown}
          checking={checking}
        />
      </Col>
      <TriggerCountdown setCountdown={setCountdown} />
    </Row>
  );
};
export default RegisterVerify;
